import(/* webpackMode: "eager" */ "/app/src/modules/auth/page/login.tsx")